import NodeModel from 'rise-ui/models/types/node.js';

import { attr, hasMany } from '@ember-data/model';

export default class FileGalleryFileModel extends NodeModel {
  @attr('string') uuid;
  @attr('string') filename;
  @attr('string') url;
  @hasMany('file-gallery', { async: true, inverse: 'files' }) fileGalleries;
}
